export function getInputRules(item) {
    if (item.dataType === "String") {
        return [{required: true, message: item.name + '必填'}]
    }
    else if (item.dataType === "Int") {
        return [
            {required: true, message: item.name + '必填'},
            {validator: (value, rule) => value >= item.intMinValue, message: `${item.name}不能小于${item.intMinValue}`},
            {validator: (value, rule) => value <= item.intMaxValue, message: `${item.name}不能大于${item.intMaxValue}`},
        ]
    }
    else if (item.dataType === "Float") {
        return [
            {required: true, message: item.name + '必填'},
            {validator: (value, rule) => value >= item.floatMinValue, message: `${item.name}不能小于${item.floatMinValue}`},
            {validator: (value, rule) => value <= item.floatMaxValue, message: `${item.name}不能大于${item.floatMaxValue}`},
        ]
    }
    else if (item.dataType === "Boolean") {
        return [{required: true, message: item.name + '必填'}]
    }
    else if (item.dataType === "Date") {
        return [{required: true, message: item.name + '必填'}]
    }
    else if (item.dataType === "Enum") {
        const items = item.enumItems;
        return [
            {required: true, message: item.name + '必填'},
            {enum: items}
        ]
    }
    else if (item.dataType === "Array") {
        return [{required: true, message: item.name + '必填'}]
    }

}
